// Libs
import React from 'react'

// CSS
import './styles.scss'

const DashboardPercentage = ({ data }) => {
  let total = 100
  let successful = 0
  let unsuccessful = 0
  let notNegotiated = 100

  total = Number(data.successful) + Number(data.unsuccessful) + Number(data.notNegotiated)

  if (data.successful) {
    successful = Math.round((data.successful / total) * 100)
  }

  if (data.unsuccessful) {
    unsuccessful = Math.round((data.unsuccessful / total) * 100)
  }

  if (data.notNegotiated || data.notNegotiated == 0) {
    notNegotiated = 100 - (successful + unsuccessful)
  }

  const percentages = [
    { variable: 'successful', label: 'COM SUCESSO', value: successful },
    { variable: 'unsuccessful', label: 'SEM SUCESSO', value: unsuccessful },
    { variable: 'notNegotiated', label: 'NÃO NEGOCIADOS', value: notNegotiated }
  ]

  return (
    <div className="dashboard-percentage">
      {percentages.map(percentage => (
        <div key={percentage.variable} style={{ width: `${percentage.value}%` }}>
          <span className={data[percentage.variable] && percentage.value ?
            "dashboard-percentage__percentage dashboard-percentage__percentage--visible" :
            "dashboard-percentage__percentage"}>
            {percentage.value >= 5 && <p>{percentage.value >= 10 ? percentage.label : '-'}</p>}
            {percentage.value >= 5 && <p>{percentage.value}%</p>}
          </span>
        </div>
      ))}
    </div>
  )
}

export default DashboardPercentage
